import Service from './service'
export var ApiDocumentScannerMessageType;
(function (ApiDocumentScannerMessageType) {
  ApiDocumentScannerMessageType["SCANNER_DOCUMENT_REQUEST"] = "scanner.document.request"
  ApiDocumentScannerMessageType["SCANNER_DOCUMENT_RESPONSE"] = "scanner.document.response"
  ApiDocumentScannerMessageType["SCANNER_DOCUMENT_ERROR"] = "scanner.document.error"
  ApiDocumentScannerMessageType["SCANNER_DOCUMENT_STATE"] = "scanner.document.state"
  ApiDocumentScannerMessageType["SCANNER_DOCUMENT_PROGRESS"] = "scanner.document.progress"
  ApiDocumentScannerMessageType["SCANNER_DOCUMENT_FINISH"] = "scanner.document.finish"
})(ApiDocumentScannerMessageType || (ApiDocumentScannerMessageType = {}))
/**
 * Сервис для сканирования документов А4
 * @version 0.0.1
 * @since 1.9.1
 */
class DocumentScannerService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiDocumentScannerMessageType.SCANNER_DOCUMENT_RESPONSE:
          delete message.id
          delete message.type
          if (message.success && message.success === true) {
            this.resolve(this.waiters.scan)
          }
          else {
            this.reject(this.waiters.scan)
          }
          break
        case ApiDocumentScannerMessageType.SCANNER_DOCUMENT_ERROR:
          delete message.id
          delete message.type
          // if (this.scanDocumentErrorCallback) {
          //   this.scanDocumentErrorCallback(message)
          // }
          break
        case ApiDocumentScannerMessageType.SCANNER_DOCUMENT_STATE:
          delete message.id
          delete message.type
          // if (this.scanDocumentStateCallback) {
          //   this.scanDocumentStateCallback(message.state)
          // }
          break
        case ApiDocumentScannerMessageType.SCANNER_DOCUMENT_PROGRESS:
          delete message.id
          delete message.type
          // if (this.scanDocumentProgressCallback) {
          //   this.scanDocumentProgressCallback(message.progress)
          // }
          break
        case ApiDocumentScannerMessageType.SCANNER_DOCUMENT_FINISH:
          delete message.id
          delete message.type
          // if (this.scanDocumentFinishCallback) {
          //   this.scanDocumentFinishCallback(message.data)
          // }
          break
      }
    }
    /**
         * @private
         * @ignore
         */
    this.waiters = {
      scan: [],
    }
    this.messageChannel.subscribe(ApiDocumentScannerMessageType.SCANNER_DOCUMENT_RESPONSE, messageHandler)
    this.messageChannel.subscribe(ApiDocumentScannerMessageType.SCANNER_DOCUMENT_ERROR, messageHandler)
    this.messageChannel.subscribe(ApiDocumentScannerMessageType.SCANNER_DOCUMENT_STATE, messageHandler)
    this.messageChannel.subscribe(ApiDocumentScannerMessageType.SCANNER_DOCUMENT_PROGRESS, messageHandler)
    this.messageChannel.subscribe(ApiDocumentScannerMessageType.SCANNER_DOCUMENT_FINISH, messageHandler)
  }
  /**
     * Произошла ошибка при сканировании
     * @since 1.9.1
     * @param {function} callback - функция
     *
     * @example <caption>произошла ошибка при сканировании</caption>
     * robot.documentScannerService.onScanDocumentError(() => {
     *   ...
     * })
     */
  onScanDocumentError(_callback) {
    /**
         * @private
         * @ignore
         */
    // this.scanDocumentErrorCallback = callback
  }
  /**
     * Изменилось состояние сканера
     * @since 1.9.1
     * @param {function} callback - функция
     *
     * @example <caption>изменилось состояние сканера</caption>
     * robot.documentScannerService.onScanDocumentState(state => {
     *   0 - ...
     *   1 - ...
     * })
     */
  onScanDocumentState(_callback) {
    /**
         * @private
         * @ignore
         */
    // this.scanDocumentStateCallback = callback
  }
  /**
     * Изменился прогресс сканирования
     * @since 1.9.1
     * @param {function} callback - функция
     *
     * @example <caption>изменился прогресс сканирования</caption>
     * robot.documentScannerService.onScanDocumentProgress(progress => {
     *   где progress Number от 0 до 100
     * })
     */
  onScanDocumentProgress(_callback) {
    /**
         * @private
         * @ignore
         */
    // this.scanDocumentProgressCallback = callback
  }
  /**
     * Сканирование документа завершилось
     * @since 1.9.1
     * @param {function} callback - функция
     *
     * @example <caption>сканирование документа завершилось</caption>
     * robot.documentScannerService.onScanDocumentFinish(data => {
     *   // сканирование завершено
     *   data = { outputFileName : '/.....' }
     * })
     */
  onScanDocumentFinish(_callback) {
    /**
         * @private
         * @ignore
         */
    // this.scanDocumentFinishCallback = callback
  }
  /**
     * Сканировать документ
     * @since 1.9.1
     * @param {boolean} ignoreNotConnected - игнорировать статус подключения
     * @param {Number} timeout - сколько времени сканер будет ждать пока к нему что-то приложат (по умолчанию 30 сек)
     * @param {Number} mode - тип сканирования, по умолчанию MODE_GRAY = 1, MODE_LINEART=0, MODE_COLOR=2
     * @param {Number} brightness - яркость (от -127 до 128, по умолчанию 0)
     * @param {Number} resolution - разрешение (от 50 до 600, по умолчанию 300)
     * @return {Promise}
     *
     * @example <caption>сканировать документ</caption>
     * robot.documentScannerService.scanDocument().then(() => {
     *   ...
     * })
     */
  // tslint:disable-next-line: max-line-length
  scanDocument(ignoreNotConnected = false, timeout = 30, mode = 1, brightness = 0, resolution = 300) {
    return this.execute({
      type: ApiDocumentScannerMessageType.SCANNER_DOCUMENT_REQUEST,
      ignore_not_connected: ignoreNotConnected,
      timeout,
      mode,
      brightness,
      resolution,
    }, this.waiters.scan)
  }
}
export default DocumentScannerService
